import * as Action from '../constants/toggleConstants'
export const openToggle = (itemId = null) => async (dispatch) => {
    dispatch({ type: Action.OPEN_BOTTOM_TOGGLE, payload: itemId });
}
export const closeToggle = () => async (dispatch) => {
    dispatch({ type: Action.CLOSE_BOTTOM_TOGGLE });
}
